import {observer} from "mobx-react";
import * as React from "react";
import ListPurchaseOrderFeature from "./ListPurchaseOrderFeature";
import {useNavigate} from "react-router-dom";
import {useApplication} from "../../ApplicationProvider";
import {useNavigatorFeature} from "../../useFeature";
import LayoutContentWrapper from "../../components/layout/LayoutContentWrapper";
import LayoutContentToolbar from "../../components/layout/LayoutContentToolbar";
import {Link} from "@mui/material";
import FilledButton from "../../components/buttons/FilledButton";
import RedoIcon from '@mui/icons-material/Redo';
import Table from "../../components/table/Table";

function ListPurchaseOrderScreen() {
    const application = useApplication();
    const navigator = useNavigate();
    const feature = useNavigatorFeature(() => new ListPurchaseOrderFeature(application, navigator), navigator);

    const isFeatureReady = (feature) => {
        return feature && feature.loaded
    }

    const listOrdersContent = () => {
        return (
            <div>
                <LayoutContentToolbar title="Órdenes de Compra">
                    <FilledButton onClick={() => feature.retryPurchaseOrdersValidationProcess()}>
                        <RedoIcon fontSize="small"/>
                        Reintentar validaciones
                    </FilledButton>
                </LayoutContentToolbar>

                <Table columns={feature.columnsContent()} rows={feature.presentedPurchaseOrders()}
                       columnsRenderer={{
                           orderUrl: (params) => <Link href={params.value.url}>{params.value.urlName}</Link>
                       }}/>
            </div>
        )
    }

    return (
        <LayoutContentWrapper isLoading={!isFeatureReady(feature)} renderContent={() => listOrdersContent()}/>
    )
}

export default observer(ListPurchaseOrderScreen)
